import {
	LabelChangeForUpdate,
	updateLabels
} from 'src/apps/web-sdks/services/api/LabelUpdateApiService';
import { IWebSdkTest } from 'src/apps/web-sdks/types/WebSdkDashboardServiceTypes';
import { ConfigurationLabel } from 'src/common/types/ConfigurationTypes';

export const handleSave = async (
	testRows: IWebSdkTest[],
	changes: LabelChangeForUpdate[],
	onClose: () => void,
	onClear: () => void,
	onSaveSuccess?: () => void,
	tenantConfiguredLabels?: ConfigurationLabel[]
): Promise<void> => {
	if (!changes.length || !testRows.length) {
		onClose();
		return;
	}

	onSaveSuccess?.();

	await updateLabels(testRows, changes, tenantConfiguredLabels);

	onClear();
	onClose();
};
